
















import Vue from 'vue';

export default Vue.extend({
  name: 'CtrlAddFromListBtn',
  data: () => ({}),
  methods: {
    handleClick() {
      setTimeout(() => {
        this.$emit('click');
      }, 500);
    },
  },
});
